import React, { useState, useRef, useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import EMICalculator from "../calculator/EMICalculator";
import AgreementDetails from '../property/AgreementDetails';
import PropertySpecifications from '../property/PropertySpecifications';
import ImageCarousel from '../common/ImageCarousel';
import { formatDate } from '../../utils/formatDate';
import config from "../../config/config";
import { calculateEMI } from '../../utils/calculateEMI';
import { formatPrice } from '../../utils/priceUtils';
import Wishlisted from "../property/Wishlisted";
import { fetchProfileProperties } from '../../redux/profilePropertySlice';
import axios from "axios";
import ContactModal from "../modals/contactModal";
import { useDispatch, useSelector } from 'react-redux';
import ImageModal from '../modals/ImageModal';
import { useNavigate } from "react-router-dom";
import { eventEmitter } from "../EventEmitter";
import { Adv } from '../common/Adv';
import AdvProject from '../common/AdvProject';
import { sendWhatsappMessageApi } from '../../api/commonApi';
import AdvertisementType1 from '../AdvertisementType1';
import generateSlug from '../common/generateSlug';
import AlertModal from '../modals/AlertModal';


const Listing = ({ service = 'sell', user, list = [] }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = config.getAuthToken();
    const [contactMobile, setContactMobile] = useState('');
    const [displayTitle, setDisplayTitle] = useState('');

    const { properties, status, error1 } = useSelector((state) => state.profileProperty);
    const [contactedId, setContactedId] = useState([]);
    const [wishlist, setWishlist] = useState([]);
    const [viewId, setViewId] = useState([]);
    const [imagesModal, setImagesModal] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(null);
    const [project, setProject] = useState([]);

    const [showModal, setShowModal] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);

    const handleLinkClick = (project) => {


       const url = generateSlug(project);

        const propertyIds = project?.property_ids;

        localStorage.setItem('last-property-seen', JSON.stringify({ id: propertyIds, typeWithId: url }))
// alert(url);
        window.location.href = url; // Navigate manually
    };



    useEffect(() => {
        if (properties?.contacted) {
            setContactedId(properties.contacted.map(Number)); // Convert to integers

        }
        if (properties?.viewed) {
            setViewId(properties.viewed.map(Number)); // Convert to integers
        }
        if (properties?.wishlist) {
            setWishlist(properties.wishlist.map(Number)); // Convert to integers
        }
    }, [properties]);

    const contactedProperty = async (property, isContacted = false) => {


        try {
            //alert(property.property_ids)
            const formData = new FormData();
            formData.append('property_id', property.property_ids);
            formData.append('user_id', user?.data?.id);
            formData.append('name', user?.data?.name);
            formData.append('email', user?.data?.email);
            formData.append('mobile', user?.data?.mobile);
            formData.append('property_owner_id', property?.user_id);
            formData.append('contacted', 1);
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/contactedProperty`, // Replace with your API URL
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${config.getAuthToken()}`, // Attach Bearer token
                        'Content-Type': 'application/json', // Set correct content type for file upload
                    },
                }
            );

            if (response.status) {
                setContactedId((prevContactedIds) => {
                    let propertyIds = [];

                    if (Array.isArray(property.property_ids)) {
                        // Convert all values to numbers
                        propertyIds = property.property_ids.map(Number);
                    } else if (typeof property.property_ids === "string") {
                        // If it's a comma-separated string, split and convert to numbers
                        propertyIds = property.property_ids.split(",").map(id => Number(id.trim()));
                    } else if (property.property_ids !== undefined && property.property_ids !== null) {
                        // Convert single value to a number and wrap in an array
                        propertyIds = [Number(property.property_ids)];
                    }

                    // Merge with previous IDs, ensure uniqueness
                    return Array.from(new Set([...prevContactedIds, ...propertyIds]));
                });

                setContactMobile(response.data.contact_detail);


                if (isContacted) {
                    await sendWhatsappMessageApi({
                        slug: 'user_property_contacted',
                        mobile: response.data?.contact_detail,
                        name: response.data?.name,
                        title: response.data?.title,
                        location: response.data?.location,
                        link: response.data?.link,
                        token: token,
                        user_mobile: user?.data?.mobile,
                        user_name: user?.data?.name,
                        user_email: user?.data?.email,

                    });
                }
            }

        } catch (error) {
            console.error('Error updating:', error);
            alert('Something Went Wrong. Please try again.');
        }
    };

    const handleDispatch = () => {
        if (user?.data?.id != null) {
            dispatch(fetchProfileProperties(user?.data?.id));
        }

    }

    useEffect(() => {

        if (user?.data?.id != null) {
            dispatch(fetchProfileProperties(user?.data?.id));
        }
    }, [user?.data?.id]);

    const handleImagesModal = (project) => {
        setImagesModal(true);

        setProject(project)
    };

    const handleShowModal = (project, displayTitle, isContacted) => {
        if (!user?.data?.id) {
            eventEmitter.emit('loginFirst', true);
            return
        }
        setSelectedProject(project);
        setDisplayTitle(displayTitle);
        setShowModal(true);
        contactedProperty(project, isContacted);
    };

    const handleImagesModalClose = () => {
        setImagesModal(false);
        setProject([])
    };

    const openEmiModal = (id) => {
        setIsModalOpen(id);
        //   setIsModalOpen((prevId) => (prevId === id ? null : id));
    };
    const closeEmiModal = () => {
        setIsModalOpen(null);
    };

    const listLength = list?.length || 0;

    // Generate two non-overlapping ad positions with at least a gap (e.g., 2 items apart)
    const [adIndex1, adIndex2] = useMemo(() => {
        if (listLength < 3) return [0, 1];

        let first = Math.floor(Math.random() * (listLength - 2));
        let second;
        do {
            second = Math.floor(Math.random() * listLength);
        } while (Math.abs(first - second) < 2 || first === second);

        return [first, second];
    }, [listLength]);

    const renderAd = (index) => {
        if (index === adIndex1) return <Adv />;
        if (index === adIndex2) return <AdvProject />;
        return null;
    };

    const [showAlertModal, setShowAlertModal] = useState(false);
      const handleOpenModal = () => {
      setShowAlertModal(true);
    
      // Auto close after 2 seconds
      setTimeout(() => {
        setShowAlertModal(false);
      }, 1500);
    };
    return (
        <>

            {list?.length > 0 ? (
                list?.map((project, index) => {
                    // const displayTitle = project?.property_service === 'living'
                    //     ? project?.pg_name
                    //     : project?.project_name
                    //         ? project?.project_name
                    //         : (project?.specifications?.sizes?.[0]
                    //             ? `${project?.specifications?.sizes?.[0]} Sq.Ft. ${project?.property_type}`
                    //             : '');

                    const displayTitle = project?.title;
                    return (
                        <>
                            <React.Fragment key={index}>
                                {renderAd(index)} {/* Show ad if index matches */}

                                <Link
                                    style={{ color: '#343434', textDecoration: "none" }}
                                    onClick={() => handleLinkClick(project)}
                                >
                                    <div className="list-card p-3 mb-4" key={index}>
                                        <div className='d-flex listcardbox'>
                                            <ImageCarousel project={project} handleImagesModal={handleImagesModal} />
                                            <div className='d-grid contbox'>
                                                <div className="list-header cont-property-header">
                                                    <div className="d-flex flex-grow-1 align-items-start gap-4">
                                                        <h3 style={{ textTransform: "capitalize" }}>
                                                            {displayTitle}
                                                        </h3>
                                                        {/* {['rent'].includes(project?.property_service) && !['commercial'].includes(project?.property_category) && (
                                                            project?.agreement_details &&
                                                            <AgreementDetails agreementdetails={project?.agreement_details} />
                                                        )} */}
                                                    </div>
                                                    <div className='header-btntray1 d-flex'>
                                                        <Wishlisted data={project} wishlist={wishlist} user={user} token={config.getAuthToken()} handleDispatch={handleDispatch}  handleOpenModal={handleOpenModal} />
                                                    </div>
                                                </div>
                                                <div className='agrebxfordwnalin'>
                                                    <div className='property-pricing mt-3'>

                                                        <span>₹ {project?.property_service == 'living' ? project?.specifications?.price_range : project?.price_range}
                                                            <span className='text-secondary'>
                                                                {project?.brokerage_negotiable == 1 ? 'negotiable' : ''}
                                                            </span>
                                                        </span>

                                                        <span className='property-emi' onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation(); // Prevent div click
                                                            openEmiModal(index);
                                                        }}>
                                                            <span className='desk'>

                                                                {!['rent', 'commercialbuy', 'commerciallease', 'living'].includes(project?.property_service) && (
                                                                    <>
                                                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                            <path fillRule="evenodd" clipRule="evenodd" d="M12.4688 0V14H1.53125V0H12.4688ZM5.03125 10.5H3.71875V11.8125H5.03125V10.5ZM7.65625 10.5H6.34375V11.8125H7.65625V10.5ZM10.2812 10.5H8.96875V11.8125H10.2812V10.5ZM5.03125 7.875H3.71875V9.1875H5.03125V7.875ZM7.65625 7.875H6.34375V9.1875H7.65625V7.875ZM10.2812 7.875H8.96875V9.1875H10.2812V7.875ZM5.03125 5.25H3.71875V6.5625H5.03125V5.25ZM7.65625 5.25H6.34375V6.5625H7.65625V5.25ZM10.2812 5.25H8.96875V6.5625H10.2812V5.25ZM11.1562 1.3125H2.84375V3.9375H11.1562V1.3125Z" fill="#EB622E" />
                                                                        </svg>

                                                                        (₹ EMI starts at {calculateEMI(project?.property_price?.[0], 30, 6.95)})
                                                                        {isModalOpen === index && (
                                                                            <EMICalculator closeEmiModal={closeEmiModal} />
                                                                        )}
                                                                    </>
                                                                )}
                                                            </span>
                                                        </span>
                                                    </div>

                                                    {['rent'].includes(project?.property_service) && !['commercial'].includes(project?.property_category) && (
                                                        project?.agreement_details &&
                                                        <AgreementDetails agreementdetails={project?.agreement_details} />
                                                    )}
                                                </div>
                                                <div className="mt-1 mb-1">
                                                    <strong>{project?.property_title}</strong> {project?.localities_name}
                                                </div>

                                                <p className="property-description line-clamp desk">
                                                    {project.property_description}
                                                </p>

                                                <div className='specify desk'>
                                                    {project.specifications && <PropertySpecifications specifications={project.specifications} />}
                                                </div>

                                                <div className="builder-info1 mt-2">
                                                    {project?.builder_name && (
                                                        <>
                                                            <div className='builderimg desk'>
                                                                {project.builder_logo ? (
                                                                    <img
                                                                        src={project?.builder_logo}
                                                                        alt="Project Logo"
                                                                        onError={(e) => {
                                                                            e.target.onerror = null;
                                                                            e.target.style.display = 'none';
                                                                            e.target.nextSibling.style.display = 'flex';
                                                                        }}
                                                                    />
                                                                ) : null}
                                                                <div className='projectFirstLetter' style={{ display: project.builder_logo ? 'none' : 'flex' }}>
                                                                    {project.builder_name?.charAt(0).toUpperCase()}
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                    <div className='builder-info-detail justify-content-between'>
                                                        <div className='d-grid gap-1 desk'>
                                                            <h5>{project.builder_name}</h5>
                                                            <span style={{ fontSize: '10px', color: '#999' }}>
                                                                {project?.updated_at ? 'Updated On : ' + formatDate(project.updated_at, "MM-YYYY") : ''}
                                                            </span>
                                                        </div>

                                                        {contactedId.some(item =>
                                                            (Array.isArray(project?.property_ids) ? project.property_ids : [project.property_ids]).includes(item)
                                                        ) ? (
                                                            <button className='btn contactedseller-btn' onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                handleShowModal(project, displayTitle, false);
                                                            }}>
                                                                Contacted
                                                            </button>
                                                        ) : (
                                                            <button className='btn contseller-btn' onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                handleShowModal(project, displayTitle, true);
                                                            }}>
                                                                Contact Seller
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>

                            </React.Fragment>
                        </>
                    );
                })
            ) : (
                <div>No Property Found</div>
            )}


            {showModal &&
                <ContactModal handleClose={() => {
                    setShowModal(false)
                    setContactMobile('')

                }} project={selectedProject} displayTitle={displayTitle} contactMobile={contactMobile} />
            }
            {imagesModal &&
                <ImageModal project={project} contactedId={contactedId} handleImagesModalClose={handleImagesModalClose} handleShowModal={handleShowModal} user={user} token={token} handleDispatch={handleDispatch} properties={properties} />
            }
            {showAlertModal && 
                <AlertModal />
            }
        </>
    );
};

export default Listing;
